export default "__VITE_ASSET__BlQqq42o__"